export default __webpack_public_path__ + "static/acct-img-2c29c3e2fa6741cf750b4fb314e1ca71.png";